import { Injectable } from '@angular/core';

@Injectable()
export class AdImageConfig {
  /**
   * é»è®¤å¤§å°ï¼é»è®¤å¼ï¼`64`ï¼åä½ï¼px
   */
  size?: number = 64;

  /**
   * éè¯¯å¾ç
   */
  error?: string = './assets/img/logo.svg';
}
